export const feedPostsQueryKey = () => ["home", "feed", "posts"]

export const feedPartnersQueryKey = () => ["home", "feed", "partners"]

export const feedEventsQueryKey = () => ["events", "home", "feed"]
